@if (bindingProperty && fieldName) {
    <div class="container">
        @for (item of bindingProperty; track trackByFn(i); let i = $index) {
            <div class="inputWrapper">
                <input
                    type="text"
                    [id]="fieldName + i"
                    placeholder="Add {{ label }}"
                    [(ngModel)]="bindingProperty[i]"
                    (ngModelChange)="dataChanged()"
                    [name]="fieldName + i"
                    [readOnly]="isReadOnly"
                    [ngClass]="{ error: errorIndexes.hasOwnProperty(i) }"
                    [appTrimSpaces]="$safeNavigationMigration(additionalInfo?.shouldTrimSpaces)"
                    autocomplete="disabled"
                    aria-autocomplete="none"
                />
                <app-validation-error-message
                    [show]="errorIndexes.hasOwnProperty(i)"
                    [errors]="[{ errorMessage: errorIndexes[i] }]"
                ></app-validation-error-message>
                @if (!isReadOnly) {
                    <button class="removeIcon resetStyles" (click)="removeField(i)">
                        <div class="icon" [innerHTML]="removeFieldIcon"></div>
                    </button>
                }
            </div>
        }
        @if (!isReadOnly) {
            <button class="action resetStyles" (click)="addNewField()">+ Add {{ label }}</button>
        }
    </div>
}
